module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = _vm.settingLink == 'TrackingStatuses', _obj ),
    attrs: {
      "to": {
        name: 'TrackingStatuses'
      }
    }
  }, [_c('span', [_vm._v("Статусы")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj$1 = {}, _obj$1[_vm.settingsLinkActiveClass] = _vm.settingLink == 'Printers', _obj$1 ),
    attrs: {
      "to": {
        name: 'Printers'
      }
    }
  }, [_c('span', [_vm._v("Принтеры")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-374370a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/menus/SettingsMenu.vue
// module id = 1109
// module chunks = 0